<kl-form-container
  [mode]="'edit'"
  [title]="'email_settings' | translate"
  [alertMessage]="alertMessage"
  [pageId]="tabId ? tabId : modalId"
  [alertShow]="
    alertShow || requiredError || testMailFormNotValid || mailSendSuccess
  "
  [alertType]="alertType"
  (onCloseAlert)="
    alertShow = false;
    requiredError = false;
    testMailFormNotValid = false;
    mailSendSuccess = false
  "
  (onCommitSave)="
    EmailSettingsForm.valid
      ? commitSave()
      : handleError('required_fields_must_be_entered', 'requiredError')
  "
>
  <accordion>
    <accordion-group
      [isOpen]="isOpenFirstAccordion"
      (isOpenChange)="isOpenFirstAccordion = $event"
    >
      <div accordion-heading class="clearfix">
        {{ "general" | translate }}
        <span class="badge badge-secondary float-right pull-right">
          <i
            class="fal"
            [ngClass]="isOpenFirstAccordion ? 'fa-minus' : 'fa-plus'"
          ></i>
        </span>
      </div>
      <form #EmailSettingsForm="ngForm" novalidate>
        <div class="col-md-12 col-sm-12 row">
          <div class="col-md-6 col-sm-12">
            <div class="form-group row">
              <label for="host_name" class="col-md-4">
                <small
                  >{{ "host_name" | translate }}
                  <i class="text-danger">*</i></small
                >
              </label>
              <div class="col-md-8">
                <input
                  class="form-control form-control-sm"
                  maxlength="100"
                  [disabled]="isReadOnly"
                  #ServerName="ngModel"
                  name="host_name"
                  id="host_name"
                  [ngClass]="
                    requiredError && ServerName.invalid ? 'errorInput' : ''
                  "
                  [(ngModel)]="entity.host_name"
                  required
                />
                <div
                  *ngIf="requiredError && ServerName.invalid"
                  class="errorMessage"
                >
                  {{ "important_area" | translate }}
                </div>
              </div>
            </div>
            <div class="form-group row">
              <label for="smtp_user_name" class="col-md-4">
                <small>
                  {{ "user_name" | translate }}
                  <i class="text-danger">*</i></small
                >
              </label>
              <div class="col-md-8 col-sm-12">
                <input
                  type="text"
                  id="smtp_user_name"
                  name="smtp_user_name"
                  class="form-control form-control-sm"
                  required
                  maxlength="100"
                  #UserName="ngModel"
                  [disabled]="isReadOnly"
                  [autocomplete]="false"
                  [ngClass]="
                    requiredError && UserName.invalid ? 'errorInput' : ''
                  "
                  [(ngModel)]="entity.user_name"
                />
                <div
                  *ngIf="requiredError && UserName.invalid"
                  class="errorMessage"
                >
                  {{ "important_area" | translate }}
                </div>
              </div>
            </div>
            <div class="form-group row">
              <label for="smtp_password" class="col-md-4">
                <small
                  >{{ "password" | translate }}
                  <i class="text-danger">*</i></small
                >
              </label>
              <div class="col-md-8">
                <input
                  type="password"
                  maxlength="50"
                  name="smtp_password"
                  id="smtp_password"
                  #PassWord="ngModel"
                  [autocomplete]="false"
                  [disabled]="isReadOnly"
                  [(ngModel)]="entity.password"
                  [ngClass]="
                    requiredError && PassWord.invalid ? 'errorInput' : ''
                  "
                  class="form-control form-control-sm"
                  required
                />
                <div
                  *ngIf="requiredError && PassWord.invalid"
                  class="errorMessage"
                >
                  {{ "important_area" | translate }}
                </div>
              </div>
            </div>
            <div class="form-group row">
              <label for="send_address" class="col-md-4">
                <small>{{ "send_address" | translate }}</small>
              </label>
              <div class="col-md-8">
                <input
                  type="text"
                  maxlength="100"
                  name="send_address"
                  id="send_address"
                  [disabled]="isReadOnly"
                  [(ngModel)]="entity.send_address"
                  class="form-control form-control-sm"
                />
              </div>
            </div>
          </div>
          <div class="col-md-6 col-sm-12">
            <div class="form-group row">
              <label for="port_number" class="col-md-4">
                <small
                  >{{ "port_number" | translate }}
                  <i class="text-danger">*</i></small
                >
              </label>
              <div class="col-md-8">
                <input
                  type="text"
                  name="port_number"
                  id="port_number"
                  #Port="ngModel"
                  [disabled]="isReadOnly"
                  klNumberInput
                  maxLength="5"
                  [(ngModel)]="entity.port_number"
                  [ngClass]="requiredError && Port.invalid ? 'errorInput' : ''"
                  class="form-control form-control-sm"
                  required
                />
                <div *ngIf="requiredError && Port.invalid" class="errorMessage">
                  {{ "important_area" | translate }}
                </div>
              </div>
            </div>
            <div class="form-group row">
              <label for="use_ssl" class="col-md-4">
                <small>{{ "use_ssl" | translate }}</small>
              </label>
              <div class="col-md-8">
                <p-checkbox
                  name="use_ssl"
                  id="use_ssl"
                  binary="true"
                  styleClass="kl-checkbox"
                  [(ngModel)]="use_ssl"
                >
                </p-checkbox>
              </div>
            </div>
            <div class="form-group row">
              <label for="timeout" class="col-md-4">
                <small
                  >{{ "timeout_with_second" | translate }}
                  <i class="text-danger">*</i></small
                >
              </label>
              <div class="col-md-8">
                <input
                  type="text"
                  name="timeout"
                  id="timeout"
                  #Timeout="ngModel"
                  [disabled]="isReadOnly"
                  klNumberInput
                  maxLength="5"
                  [(ngModel)]="entity.timeout"
                  [ngClass]="
                    requiredError && Timeout.invalid ? 'errorInput' : ''
                  "
                  class="form-control form-control-sm"
                  required
                />
                <div
                  *ngIf="requiredError && Timeout.invalid"
                  class="errorMessage"
                >
                  {{ "important_area" | translate }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="hr"></div>
        <div class="col-md-12 col-sm-12 row">
          <div class="col-md-6 col-sm-12">
            <div class="form-group row">
              <label for="mail_to" class="col-md-4">
                <small
                  >{{ "to_whom" | translate }}
                  <i class="text-danger">*</i></small
                >
              </label>
              <div class="col-md-8">
                <input
                  class="form-control form-control-sm"
                  maxlength="50"
                  [autocomplete]="false"
                  [ngClass]="testMailFormNotValid ? 'errorInput' : ''"
                  [disabled]="isReadOnly"
                  name="mail_to"
                  id="mail_to"
                  (ngModelChange)="testMailFormNotValid = false"
                  [(ngModel)]="mail.to"
                />
                <div *ngIf="testMailFormNotValid" class="errorMessage">
                  {{ "important_area" | translate }}
                </div>
              </div>
            </div>
            <div class="form-group row">
              <label for="mail_subject" class="col-md-4">
                <small>{{ "subject" | translate }}</small>
              </label>
              <div class="col-md-8">
                <input
                  class="form-control form-control-sm"
                  maxlength="100"
                  [disabled]="isReadOnly"
                  name="mail_to"
                  id="mail_subject"
                  [(ngModel)]="mail.title"
                />
              </div>
            </div>
          </div>
          <div class="col-md-6 col-sm-12">
            <div class="form-group row">
              <label for="mail_text" class="col-md-4">
                <small>{{ "text" | translate }}</small>
              </label>
              <div class="col-md-8">
                <textarea
                  class="form-control form-control-sm"
                  maxlength="500"
                  [disabled]="isReadOnly"
                  name="mail_text"
                  id="mail_text"
                  [(ngModel)]="mail.body"
                >
                </textarea>
              </div>
            </div>
            <button
              class="btn btn-greenish btn-sm pull-right position-relative"
              (click)="
                !mail.to
                  ? handleError(
                      'required_fields_must_be_entered',
                      'testMailFormNotValid'
                    )
                  : EmailSettingsForm.valid
                  ? sendTestMail()
                  : handleError(
                      'required_fields_must_be_entered',
                      'requiredError'
                    )
              "
            >
              <span class="mr-2">{{ "send_test_mail" | translate }}</span>
              <i
                *ngIf="showIndicator"
                class="fal fa-spinner fa-spin"
                style="color: #fff; font-size: 18px"
              ></i>
            </button>
          </div>
        </div>
      </form>
    </accordion-group>
  </accordion>
</kl-form-container>
